import { AnimatePresence } from "framer-motion";

// import AboutHeader from "./About/About_section_Header";
import AboutSection from "./About/About_Us";
import PresidentMessage from "./About/President__Message";
import OurSpirit from "./About/Mission";
import FAQSection from "./About/FAQ";
import Gallery from "./About/Gallery";
import AnimatedCard from "./About/Animated_Card";

import "./Css/About.css";

function About() {
  return (
    <AnimatePresence>
      {/* ID for "About Us" link */}
      <section id="about-intro">
        {/* <AboutHeader /> */}
        <AboutSection />
        <OurSpirit />
        <PresidentMessage />
      </section>
      {/* ID for "Mission & Vision" link */}
      <section id="Objectives">
        <AnimatedCard />
      </section>

      {/* ID for "FAQ" link */}
      <section id="faq">
        <FAQSection />
      </section>

      {/* ID for "Gallery" link */}
      <section id="gallery">
        <Gallery />
      </section>
    </AnimatePresence>
  );
}

export default About;
